/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */

import { ErrorMessage, Field, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { Col, Form, FormCheck, Row, Modal, Button } from "react-bootstrap";
import { useHistory, withRouter, useLocation } from "react-router-dom";
import { Texterror } from "../../../constants/Texterror";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { profileform } from "../../../constants/Validation";
import {
  getProfile,
  getProfileSession,
  updateProfile,
} from "../../../redux/actions/dbactions/profileActions";
import { refTypesList } from "../../../redux/actions/dbactions/refactions";
import { getSession } from "../../../redux/actions/authActions";
import "./style.scss"; // Import your custom CSS file
import { Header } from "../../Header";
import ProfileIcon from "../../../../assets/ProfileIcon";
import { Autocomplete, LoadScriptNext } from "@react-google-maps/api";

const LIBRARIES = ["places"];
const Profile = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const autocompleteRef = useRef();
  const { refsdata } = useSelector((state) => state.refstypes);
  const [countrySName, setCountrySName] = useState("");
  const cartItems = useSelector((state) => state?.cart?.cartItems) || [];
  const location = useLocation();
  const userData = location.state?.userData;
  const { user_profile_id } = getSession();
  const { profileData } = getProfileSession();
  const [refresh, setRefresh] = useState(false);
  const [saved, setSaved] = useState(false);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setSelectedImage(file);

    const reader = new FileReader();
    reader.onloadend = () => {};
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    dispatch(getProfile());
    dispatch(refTypesList());
  }, [dispatch]);

  useEffect(() => {
    if (refresh) {
      dispatch(getProfile());
      setRefresh(false);
    }
  }, [refresh]);

  const handleDeleteMyAccount = () => {
    setShowModal(true);
  };
  const handleConfirmDelete = () => {
    setShowModal(false);
    dispatch(
      updateProfile({
        sys_active_yn: "D",
        sys_user_id: user_profile_id,
        user_id: user_id,
      })
    );

    //dispatch(logout(navigate, mobile));
  };

  const handleCancelDelete = () => {
    setShowModal(false);
  };

  const titlename = refsdata.usr?.user_title || [];

  const {
    user_first_name,
    user_last_name,
    user_email,
    addr_street1,
    addr_type_id,
    addr_street2,
    addr_zipcode,
    user_id,
    user_typ_id,
    user_allow_wup_sms_yn,
    user_allow_sms_yn,
    user_photo_1,
    role_id,
    user_title_id,
    country,
    city,
    sys_active_yn,
  } = userData ? userData : profileData;
  const ownProfile = userData?.user_profile_id ? false : true;

  const user_phone_nbr = profileData?.user_phone_nbr || "";

  const handleTitleChange = (event, setFieldValue) => {
    const newSelectedTitleId = event.target.value;
    setFieldValue("user_title_id", newSelectedTitleId);
  };

  if (saved && profileData.user_has_profile_yn === "Y") {
    role_id === 5
      ? history.push("/dashboard/")
      : history.push("/dashboard/order");
    setSaved(false);
  }

  const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API;

  const handlePlaceSelected = (setFieldValue) => {
    const place = autocompleteRef.current.getPlace();

    if (place) {
      const addressComponents = place.address_components;

      const extractComponent = (type) =>
        addressComponents?.find((comp) => comp.types.includes(type))
          ?.long_name || "";
      const countryShortName = addressComponents.find((component) =>
        component.types.includes("country")
      )?.short_name;

      setFieldValue("addr_street1", place?.formatted_address);
      setFieldValue("addr_zipcode", extractComponent("postal_code"));
      setFieldValue("city", extractComponent("locality"));
      setFieldValue("country", extractComponent("country"));
      setCountrySName(countryShortName);
    }
  };

  return (
    <div className="flex flex-col">
      <Header pageTitle="Profile" icon={<ProfileIcon />} />
      <div className="card_white_box bg-gray-500">
        <h5 className="globale-title flex justify-between">
          <span>Profile</span>
        </h5>

        <LoadScriptNext googleMapsApiKey={GOOGLE_API_KEY} libraries={LIBRARIES}>
          <Formik
            initialValues={{
              city: city || "",
              country: country || "",
              user_id: user_id,
              user_title_id: user_title_id || 1,
              user_typ_id: user_typ_id,
              user_first_name: user_first_name || "",
              user_last_name: user_last_name || "",
              user_email: user_email || "",
              user_phone_nbr: user_phone_nbr || "",
              addr_street1: addr_street1 || "",
              addr_street2: addr_street2 || "",
              addr_zipcode: addr_zipcode || "",
              addr_id: "1",
              iso_cntry_id: "240",
              iso_city_id: "1",
              addr_state: "",
              addr_type_id: addr_type_id,
              user_allow_sms_yn: user_allow_sms_yn || "N",
              user_allow_wup_sms_yn: user_allow_wup_sms_yn || "N",
              role_id: role_id,
              sys_user_id: user_profile_id,
              iso_cntry_2_cde: countrySName || "",
            }}
            onSubmit={(values) => {
              const formData = new FormData();
              values.iso_cntry_2_cde = countrySName;
              Object.keys(values).forEach((key) => {
                formData.append(key, values[key]);
              });
              formData.append("sys_active_yn", sys_active_yn);
              if (selectedImage) {
                formData.append("picture", selectedImage);
              }
              formData.delete("iso_cntry_name");
              const userHasProfile = profileData.user_has_profile_yn;
              dispatch(updateProfile(formData, userData?.user_profile_id));
              dispatch(getProfile()).then(() => {
                if (userHasProfile !== "Y") {
                  let tempCart =
                    (cartItems &&
                      cartItems[0]?.svcsc_cart_jsn?.service_order_line
                        ?.length) ||
                    0;

                  if (tempCart) {
                    const facilityId =
                      (cartItems &&
                        cartItems?.[0]?.svcsc_cart_jsn?.order_svcf_id) ||
                      null;
                    history.push(`/dashboard/cart/${facilityId}?patient=null`);
                  } else {
                    history.push("/dashboard");
                  }
                }
              });

              setRefresh(true);
              setSaved(true);
            }}
            validationSchema={profileform}
          >
            {({ touched, errors, values, handleSubmit, setFieldValue }) => (
              <Form onSubmit={handleSubmit} className="px-4 md:px-14 mb-7">
                <Row>
                  <Col className="mb-3 flex justify-center">
                    <label
                      htmlFor="fileInput"
                      className="image_up  mb-2 !rounded-md overflow-hidden"
                    >
                      {selectedImage || user_photo_1 ? (
                        <div className="image-preview !items-center w-full h-full">
                          <img
                            className="w-full h-full object-contain"
                            src={
                              selectedImage
                                ? URL.createObjectURL(selectedImage)
                                : `${user_photo_1}`
                            }
                            alt="Preview"
                          />
                        </div>
                      ) : (
                        <div className="open_upload">
                          <Icon
                            icon="line-md:upload-loop"
                            className="mx-auto"
                          />
                          <p>Upload Image</p>
                        </div>
                      )}
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        id="fileInput"
                        style={{ display: "none" }}
                        onChange={handleImageChange}
                        name="svcf_photo"
                      />
                    </label>
                  </Col>
                </Row>
                <Row>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Form.Label>Title</Form.Label>
                      <Form.Select
                        className="form-control"
                        name="user_title_id"
                        aria-label="default is Mr."
                        onChange={(e) => handleTitleChange(e, setFieldValue)}
                        value={values.user_title_id}
                      >
                        <option value="">{"Select user title"}</option>
                        {titlename.map((item, index) => (
                          <option key={index} value={item.user_title_id}>
                            {item.user_title_cd}
                          </option>
                        ))}
                      </Form.Select>
                      <ErrorMessage
                        name="user_title_id"
                        component={Texterror}
                      />
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Form.Label>First Name</Form.Label>
                      <Field
                        className={`form-control ${
                          touched.user_first_name && errors.user_first_name
                            ? "is-invalid"
                            : ""
                        }`}
                        name="user_first_name"
                        type="input"
                        value={values.user_first_name}
                      />
                      <ErrorMessage
                        name="user_first_name"
                        component={Texterror}
                      />
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Form.Label>Last Name</Form.Label>
                      <Field
                        className={`form-control ${
                          touched.user_last_name && errors.user_last_name
                            ? "is-invalid"
                            : ""
                        }`}
                        name="user_last_name"
                        type="input"
                        value={values.user_last_name}
                      />
                      <ErrorMessage
                        name="user_last_name"
                        component={Texterror}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label>Email</Form.Label>
                      <Field
                        className={`form-control ${
                          touched.user_email && errors.user_email
                            ? "is-invalid"
                            : ""
                        }`}
                        name="user_email"
                        type="email"
                        value={values.user_email}
                        // disabled
                      />
                      <ErrorMessage name="user_email" component={Texterror} />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3 ">
                      <Form.Label>Phone Number</Form.Label>
                      <PhoneInput
                        country={"us"}
                        value={values.user_phone_nbr}
                        onChange={(phone) =>
                          setFieldValue("user_phone_nbr", phone)
                        }
                        enableAreaCodes={true}
                        enableSearch={true}
                        disableSearchIcon={true}
                        autoFormat={true}
                        name="user_phone_nbr"
                      />
                      <ErrorMessage
                        name="user_phone_nbr"
                        component={Texterror}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <div className="mb-3">
                      <Form.Label>Address</Form.Label>

                      <Autocomplete
                        onLoad={(autocomplete) =>
                          (autocompleteRef.current = autocomplete)
                        }
                        onPlaceChanged={() =>
                          handlePlaceSelected(setFieldValue)
                        }
                      >
                        <Field
                          className={`form-control ${
                            touched.addr_street1 && errors.addr_street1
                              ? "is-invalid"
                              : ""
                          }`}
                          name="addr_street1"
                          type="text"
                          placeholder="Enter your address"
                          value={values.addr_street1}
                        />
                      </Autocomplete>
                      <ErrorMessage name="addr_street1" component={Texterror} />
                    </div>
                    <div className="mb-3">
                      <Form.Label>Address Line 1</Form.Label>
                      <Field
                        className={`form-control ${
                          touched.addr_street2 && errors.addr_street2
                            ? "is-invalid"
                            : ""
                        }`}
                        name="addr_street2"
                        placeholder="Address line 1"
                        type="input"
                        value={values.addr_street2}
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col lg={4}>
                    <div className="mb-3">
                      <Form.Label>Country</Form.Label>

                      <Field
                        className={`form-control ${
                          touched.country && errors.country ? "is-invalid" : ""
                        }`}
                        name="country"
                        type="text"
                        placeholder="Enter country"
                        value={values.country}
                      />
                      <ErrorMessage name="country" component={Texterror} />
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="mb-3 position-relative">
                      <Form.Label>City</Form.Label>
                      <Field
                        className={`form-control ${
                          touched.city && errors.city ? "is-invalid" : ""
                        }`}
                        name="city"
                        type="text"
                        placeholder="Enter city"
                        value={values.city}
                      />

                      <ErrorMessage name="city" component={Texterror} />
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Form.Label>Zip Code(optional)</Form.Label>
                      <Field
                        className={`form-control ${
                          touched.addr_zipcode && errors.addr_zipcode
                            ? "is-invalid"
                            : ""
                        }`}
                        name="addr_zipcode"
                        placeholder="Optional Zip Code"
                        type="input"
                        value={values.addr_zipcode}
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="flex !flex-col">
                  <Col>
                    <div className="flex mb-2 items-center gap-2">
                      <FormCheck
                        name="user_allow_sms_yn"
                        type="checkbox"
                        id="user_allow_sms_yn"
                        checked={values.user_allow_sms_yn === "Y"}
                        onChange={() => {
                          setFieldValue(
                            "user_allow_sms_yn",
                            values.user_allow_sms_yn === "Y" ? "N" : "Y"
                          );
                        }}
                      />
                      <label
                        htmlFor="user_allow_sms_yn"
                        className="cursor-pointer"
                      >
                        Yes, contact me via SMS
                      </label>
                      {touched.user_allow_sms_yn &&
                        errors.user_allow_sms_yn && (
                          <div className="invalid-feedback">
                            {errors.user_allow_sms_yn}
                          </div>
                        )}
                    </div>
                  </Col>
                  <Col lg={6} md={12}>
                    <div className="flex mb-2 items-center gap-2">
                      <FormCheck
                        name="user_allow_wup_sms_yn"
                        type="checkbox"
                        id="user_allow_wup_sms_yn"
                        checked={values.user_allow_wup_sms_yn === "Y"}
                        onChange={() => {
                          setFieldValue(
                            "user_allow_wup_sms_yn",
                            values.user_allow_wup_sms_yn === "Y" ? "N" : "Y"
                          );
                        }}
                      />
                      <label
                        htmlFor="user_allow_wup_sms_yn"
                        className="cursor-pointer !text-[#c81921]"
                      >
                        Yes, contact me via Whatsapp
                      </label>
                      {touched.user_allow_wup_sms_yn &&
                        errors.user_allow_wup_sms_yn && (
                          <div className="invalid-feedback">
                            {errors.user_allow_wup_sms_yn}
                          </div>
                        )}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="mini_edit flex justify-end gap-3 mt-3">
                      <button
                        type="submit"
                        className="py-2 px-[14px] text-[13px] font-semibold bg-[#1340CD] text-white !rounded-md w-32 hover:opacity-80"
                      >
                        Submit
                      </button>
                    </div>
                  </Col>
                  {ownProfile && (
                    <a
                      href="#"
                      className="underline-link text-[13px] font-medium"
                      style={{ textDecoration: "underline" }}
                      onClick={(e) => {
                        e.preventDefault();
                        handleDeleteMyAccount();
                      }}
                    >
                      Delete my account
                    </a>
                  )}
                </Row>
              </Form>
            )}
          </Formik>
        </LoadScriptNext>
        {/* Modal for account deletion */}
        <Modal show={showModal} onHide={handleCancelDelete} centered>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Account Deletion</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete your account?{" "}
            <b>This action CANNOT be undone!</b>
            <p></p>
            Send an email to info@totalurgenthalth.com within 7 days if you want
            it restored.
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCancelDelete}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleConfirmDelete}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default withRouter(Profile);
